"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4162],{

/***/ 66602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LK": function() { return /* binding */ useGetCompanyQuery; },
/* harmony export */   "f4": function() { return /* binding */ useCreateCompanyMutation; },
/* harmony export */   "lj": function() { return /* binding */ companyService; }
/* harmony export */ });
/* unused harmony exports createCompany, getCompany */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10092);
/* harmony import */ var common_types_responses__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7061);
/* harmony import */ var common_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24125);
/* harmony import */ var _useSubscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28486);
/* harmony import */ var common_utils_urls_param__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57384);
/* harmony import */ var common_transformPagination__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50135);










var companyService = common_service__WEBPACK_IMPORTED_MODULE_1__/* .service.enhanceEndpoints */ .Xn.enhanceEndpoints({
    addTagTypes: [
        "Company",
        "Subscription"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createCompany: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "Company"
                    }
                ],
                queryFn: function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(query, _1, _2, baseQuery) {
                        var subscription, ref, data, error;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    subscription = (0,common_types_responses__WEBPACK_IMPORTED_MODULE_0__/* .convertSubscriptionToAPI */ .Up)(query.subscription);
                                    return [
                                        4,
                                        baseQuery({
                                            body: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, subscription), {
                                                groups: query.groups,
                                                members: []
                                            }),
                                            method: "POST",
                                            url: "partners/company"
                                        })
                                    ];
                                case 1:
                                    ref = _state.sent(), data = ref.data, error = ref.error;
                                    return [
                                        4,
                                        (0,_useSubscription__WEBPACK_IMPORTED_MODULE_2__/* .updateMembers */ .q0)(data.company_id, data.subscription_id, query.membersToRemove, query.subscription.members)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2,
                                        {
                                            data: data,
                                            error: error
                                        }
                                    ];
                            }
                        });
                    });
                    return function(query, _1, _2, baseQuery) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            getCompany: builder.query({
                providesTags: function(res, _, req) {
                    return [
                        {
                            id: req.id,
                            type: "Company"
                        }
                    ];
                },
                query: function(_param) {
                    var id = _param.id, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
                        "id"
                    ]);
                    return {
                        url: "partners/subscriptions?".concat((0,common_utils_urls_param__WEBPACK_IMPORTED_MODULE_8__/* .toParam */ .i)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            company_id: id
                        }, rest)))
                    };
                },
                transformResponse: function(res, _, req) {
                    return (0,common_transformPagination__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(req, res);
                }
            })
        };
    }
});
function createCompany(store, data, options) {
    return _createCompany.apply(this, arguments);
}
function _createCompany() {
    _createCompany = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(companyService.endpoints.createCompany.initiate(data, options))
            ];
        });
    });
    return _createCompany.apply(this, arguments);
}
function getCompany(store, data, options) {
    return _getCompany.apply(this, arguments);
}
function _getCompany() {
    _getCompany = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(companyService.endpoints.getCompany.initiate(data, options))
            ];
        });
    });
    return _getCompany.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateCompanyMutation = companyService /* Usage examples:
const { data, isLoading } = useGetCompanyQuery({ id: 2 }, {}) //get hook
const [createCompany, { isLoading, data, isSuccess }] = useCreateCompanyMutation() //create hook
companyService.endpoints.getCompany.select({id: 2})(store.getState()) //access data from any function
*/ .useCreateCompanyMutation, useGetCompanyQuery = companyService.useGetCompanyQuery;


/***/ }),

/***/ 28486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pI": function() { return /* binding */ getSubscription; },
  "tJ": function() { return /* binding */ getSubscriptions; },
  "AB": function() { return /* binding */ subscriptionService; },
  "q0": function() { return /* binding */ updateMembers; },
  "ho": function() { return /* binding */ useCreateSubscriptionMutation; },
  "xu": function() { return /* binding */ useGetSubscriptionQuery; },
  "Tb": function() { return /* binding */ useGetSubscriptionsQuery; },
  "A1": function() { return /* binding */ useUpdateSubscriptionMutation; }
});

// UNUSED EXPORTS: createSubscription, updateSubscription

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./common/types/responses.ts
var responses = __webpack_require__(7061);
// EXTERNAL MODULE: ./common/service.ts + 7 modules
var service = __webpack_require__(24125);
// EXTERNAL MODULE: ./common/transformPagination.ts
var transformPagination = __webpack_require__(50135);
// EXTERNAL MODULE: ./common/utils/urls/param.ts + 1 modules
var param = __webpack_require__(57384);
// EXTERNAL MODULE: ./common/services/useCompany.ts
var useCompany = __webpack_require__(66602);
// EXTERNAL MODULE: ./common/store.ts + 3 modules
var store = __webpack_require__(71185);
// EXTERNAL MODULE: ./common/toFormData.ts
var toFormData = __webpack_require__(86773);
;// CONCATENATED MODULE: ./common/services/useUbo.ts









var uboService = service/* service.enhanceEndpoints */.Xn.enhanceEndpoints({
    addTagTypes: [
        "Ubo"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createUbo: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "Ubo"
                    }
                ],
                query: function(query) {
                    return {
                        body: (0,toFormData/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query.data), {
                            documents: undefined
                        })),
                        method: "POST",
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/identifications")
                    };
                }
            }),
            deleteUbo: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "Ubo"
                    }
                ],
                query: function(query) {
                    return {
                        body: {},
                        method: "DELETE",
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/identifications/").concat(query.id)
                    };
                },
                transformResponse: function(res) {
                    (0,store/* getStore */.b)().dispatch(useCompany/* companyService.util.invalidateTags */.lj.util.invalidateTags([
                        "Company"
                    ]));
                    (0,store/* getStore */.b)().dispatch(subscriptionService.util.invalidateTags([
                        "Subscription"
                    ]));
                    return res;
                }
            }),
            getUbos: builder.query({
                providesTags: function(res) {
                    return [
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "Ubo"
                        }
                    ];
                },
                query: function(query) {
                    return {
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/identifications")
                    };
                },
                transformResponse: function(res) {
                    return res;
                }
            }),
            updateUbo: builder.mutation({
                invalidatesTags: function(res) {
                    return [
                        {
                            id: "LIST",
                            type: "Ubo"
                        },
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "Ubo"
                        }, 
                    ];
                },
                query: function(query) {
                    return {
                        body: (0,toFormData/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query.data), {
                            documents: undefined
                        })),
                        method: "PUT",
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/identifications/").concat(query.data.id)
                    };
                },
                transformResponse: function(res) {
                    (0,store/* getStore */.b)().dispatch(useCompany/* companyService.util.invalidateTags */.lj.util.invalidateTags([
                        "Company"
                    ]));
                    (0,store/* getStore */.b)().dispatch(subscriptionService.util.invalidateTags([
                        "Subscription"
                    ]));
                    return res;
                }
            })
        };
    }
});
function createUbo(store, data, options) {
    return _createUbo.apply(this, arguments);
}
function _createUbo() {
    _createUbo = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboService.endpoints.createUbo.initiate(data, options))
            ];
        });
    });
    return _createUbo.apply(this, arguments);
}
function deleteUbo(store, data, options) {
    return _deleteUbo.apply(this, arguments);
}
function _deleteUbo() {
    _deleteUbo = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboService.endpoints.deleteUbo.initiate(data, options))
            ];
        });
    });
    return _deleteUbo.apply(this, arguments);
}
function getUbos(store, data, options) {
    return _getUbos.apply(this, arguments);
}
function _getUbos() {
    _getUbos = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboService.endpoints.getUbos.initiate(data, options))
            ];
        });
    });
    return _getUbos.apply(this, arguments);
}
function updateUbo(store, data, options) {
    return _updateUbo.apply(this, arguments);
}
function _updateUbo() {
    _updateUbo = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboService.endpoints.updateUbo.initiate(data, options))
            ];
        });
    });
    return _updateUbo.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateUboMutation = uboService /* Usage examples:
const { data, isLoading } = usegetUbosQuery({ id: 2 }, {}) //get hook
const [createUbo, { isLoading, data, isSuccess }] = useCreateUboMutation() //create hook
uboService.endpoints.getUbos.select({id: 2})(store.getState()) //access data from any function
*/ .useCreateUboMutation, useDeleteUboMutation = uboService.useDeleteUboMutation, useGetUbosQuery = uboService.useGetUbosQuery, useUpdateUboMutation = uboService.useUpdateUboMutation;

;// CONCATENATED MODULE: ./common/services/useSubscription.ts











var updateMembers = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(companyId, subscriptionId, membersToRemove, members) {
        var deletes, updates;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all((membersToRemove || []).map(function(v) {
                            return deleteUbo((0,store/* getStore */.b)(), {
                                company_id: companyId,
                                id: v,
                                subscription_id: subscriptionId
                            });
                        }))
                    ];
                case 1:
                    deletes = _state.sent();
                    return [
                        4,
                        Promise.all((members || []).map(function(v) {
                            return v.id ? updateUbo((0,store/* getStore */.b)(), {
                                company_id: companyId,
                                data: v,
                                subscription_id: subscriptionId
                            }) : createUbo((0,store/* getStore */.b)(), {
                                company_id: companyId,
                                data: v,
                                subscription_id: subscriptionId
                            });
                        }))
                    ];
                case 2:
                    updates = _state.sent();
                    return [
                        2,
                        updates.concat(deletes)
                    ];
            }
        });
    });
    return function updateMembers(companyId, subscriptionId, membersToRemove, members) {
        return _ref.apply(this, arguments);
    };
}();
var subscriptionService = service/* service.enhanceEndpoints */.Xn.enhanceEndpoints({
    addTagTypes: [
        "Subscription"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createSubscription: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "Subscription"
                    }
                ],
                queryFn: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(query, _1, _2, baseQuery) {
                        var ref, data, error;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        baseQuery({
                                            body: (0,responses/* convertSubscriptionToAPI */.Up)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query.subscription), {
                                                members: []
                                            })),
                                            method: "POST",
                                            url: "partners/company/".concat(query.company_id, "/subscriptions")
                                        })
                                    ];
                                case 1:
                                    ref = _state.sent(), data = ref.data, error = ref.error;
                                    return [
                                        4,
                                        updateMembers(query.company_id, data.subscription_id, query.membersToRemove, query.subscription.members)
                                    ];
                                case 2:
                                    _state.sent();
                                    (0,store/* getStore */.b)().dispatch(useCompany/* companyService.util.invalidateTags */.lj.util.invalidateTags([
                                        "Company"
                                    ]));
                                    return [
                                        2,
                                        {
                                            data: data,
                                            error: error
                                        }
                                    ];
                            }
                        });
                    });
                    return function(query, _1, _2, baseQuery) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            getSubscription: builder.query({
                providesTags: function(res) {
                    return [
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "Subscription"
                        }
                    ];
                },
                query: function(query) {
                    return {
                        url: "partners/company/".concat(query.customerId, "/subscriptions/").concat(query.id)
                    };
                },
                transformResponse: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(res, _, req) {
                        var data;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getUbos((0,store/* getStore */.b)(), {
                                            company_id: req.customerId,
                                            subscription_id: req.id
                                        }, {
                                            forceRefetch: true
                                        })
                                    ];
                                case 1:
                                    data = _state.sent().data;
                                    return [
                                        2,
                                        (0,responses/* convertAPISubscriptionToNormal */.ji)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res), {
                                            members: data.results
                                        }))
                                    ];
                            }
                        });
                    });
                    return function(res, _, req) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            getSubscriptions: builder.query({
                providesTags: [
                    {
                        id: "LIST",
                        type: "Subscription"
                    }
                ],
                query: function(q) {
                    return {
                        responseHandler: q.export ? "text" : "json",
                        url: "partners/subscriptions?".concat((0,param/* toParam */.i)(q))
                    };
                },
                transformResponse: function(res, _, req) {
                    if (req.export) {
                        return res;
                    }
                    return (0,transformPagination/* default */.Z)(req, res);
                }
            }),
            updateSubscription: builder.mutation({
                invalidatesTags: function(res) {
                    return [
                        {
                            id: "LIST",
                            type: "Subscription"
                        },
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "Subscription"
                        }, 
                    ];
                },
                queryFn: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(query, _1, _2, baseQuery) {
                        var newData, body, ref, data, error;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    (0,store/* getStore */.b)().dispatch(useCompany/* companyService.util.invalidateTags */.lj.util.invalidateTags([
                                        "Company"
                                    ]));
                                    newData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query.subscription), {
                                        members: undefined
                                    });
                                    body = (0,responses/* convertSubscriptionToAPI */.Up)(newData);
                                    return [
                                        4,
                                        baseQuery({
                                            body: body,
                                            method: "PUT",
                                            url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription.id)
                                        })
                                    ];
                                case 1:
                                    ref = _state.sent(), data = ref.data, error = ref.error;
                                    return [
                                        4,
                                        updateMembers("".concat(query.company_id), "".concat(query.subscription.id), query.membersToRemove, query.subscription.members)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2,
                                        {
                                            data: data,
                                            error: error
                                        }
                                    ];
                            }
                        });
                    });
                    return function(query, _1, _2, baseQuery) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })
        };
    }
});
function getSubscriptions(store, data, options) {
    return _getSubscriptions.apply(this, arguments);
}
function _getSubscriptions() {
    _getSubscriptions = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(subscriptionService.endpoints.getSubscriptions.initiate(data, options))
            ];
        });
    });
    return _getSubscriptions.apply(this, arguments);
}
function createSubscription(store, data, options) {
    return _createSubscription.apply(this, arguments);
}
function _createSubscription() {
    _createSubscription = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(subscriptionService.endpoints.createSubscription.initiate(data, options))
            ];
        });
    });
    return _createSubscription.apply(this, arguments);
}
function updateSubscription(store, data, options) {
    return _updateSubscription.apply(this, arguments);
}
function _updateSubscription() {
    _updateSubscription = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(subscriptionService.endpoints.updateSubscription.initiate(data, options))
            ];
        });
    });
    return _updateSubscription.apply(this, arguments);
}
function getSubscription(store, data, options) {
    return _getSubscription.apply(this, arguments);
}
function _getSubscription() {
    _getSubscription = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(subscriptionService.endpoints.getSubscription.initiate(data, options))
            ];
        });
    });
    return _getSubscription.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateSubscriptionMutation = subscriptionService /* Usage examples:
const { data, isLoading } = useGetSubscriptionsQuery({ id: 2 }, {}) //get hook
const [createSubscription, { isLoading, data, isSuccess }] = usecreateSubscriptionMutation() //create hook
subscriptionService.endpoints.getSubscriptions.select({id: 2})(store.getState()) //access data from any function
*/ .useCreateSubscriptionMutation, useGetSubscriptionQuery = subscriptionService.useGetSubscriptionQuery, useGetSubscriptionsQuery = subscriptionService.useGetSubscriptionsQuery, useUpdateSubscriptionMutation = subscriptionService.useUpdateSubscriptionMutation;


/***/ }),

/***/ 86773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toFormData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);


function toFormData(data) {
    var parentKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", formData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new FormData();
    if (typeof data === "string") {
        formData.append(parentKey, data);
    } else if (typeof data === "number") {
        formData.append(parentKey, data.toString());
    } else if (typeof data === "boolean") {
        formData.append(parentKey, data ? "true" : "false");
    } else if (data === null) {
    // formData.append(parentKey, 'null')
    } else if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data, Date)) {
        formData.append(parentKey, data.toISOString());
    } else if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data, File)) {
        formData.append(parentKey, data);
    } else if (data !== null && typeof data !== "undefined") {
        // Arrays and objects
        Object.entries(data).forEach(function(entry) {
            var _entry = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(entry, 2), key = _entry[0], value = _entry[1];
            toFormData(value, parentKey ? "".concat(parentKey, "[").concat(key, "]") : key.toString(), formData);
        });
    }
    return formData;
}


/***/ }),

/***/ 95894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ safeParseEventValue; }
/* harmony export */ });
function safeParseEventValue(e) {
    // safe attempt to parse form value
    if (!e) {
        return e;
    }
    if (!e.target) {
        return e;
    }
    var target = e.target;
    if (target.getAttribute) {
        return target.getAttribute("type") === "checkbox" || target.getAttribute("type") === "radio" ? target.getAttribute("checked") : typeof target.value === "string" ? target.value : target.getAttribute("data-value") || target.getAttribute("value");
    }
    if (target && target.textContent) {
        return e.target.textContent;
    }
    return target ? target.value : e;
}


/***/ }),

/***/ 73255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ camelCase; }
/* harmony export */ });
function camelCase(val) {
    // hello world > Hello world
    return val ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : "";
}


/***/ }),

/***/ 70752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ enumeration; }
/* harmony export */ });
/* harmony import */ var _camelCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73255);

var enumeration = {
    get: function get(value) {
        // MY_CONSTANT > My constant
        if (!value) {
            return "";
        }
        return (0,_camelCase__WEBPACK_IMPORTED_MODULE_0__/* .camelCase */ .e)("".concat(value).replace(/_/g, " "));
    },
    set: function set(value) {
        // My Constant > MY_CONSTANT
        return value ? "".concat(value).replace(/ /g, "_").toUpperCase() : "";
    }
};


/***/ }),

/***/ 84376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var themes = {
    danger: "bg-danger text-danger bg-opacity-10",
    info: "bg-info text-info bg-opacity-10",
    primary: "bg-primary text-primary bg-opacity-10",
    secondary: "bg-secondary text-secondary bg-opacity-10",
    success: "bg-success text-success bg-opacity-10",
    warning: "bg-warning text-warning bg-opacity-10"
};
var sizes = {
    counter: "badge--counter",
    default: "",
    dot: "badge--dot"
};
var Badge = function(param) {
    var children = param.children, className = param.className, size = param.size, _theme = param.theme, theme = _theme === void 0 ? "primary" : _theme;
    var themeClass = themes[theme];
    var sizeClass = size && sizes[size];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("badge fw-semibold d-flex fs-xs text-nowrap align-items-center justify-content-center text-center fs-xss", themeClass, sizeClass, className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Badge);


/***/ }),

/***/ 17977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50450);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);





var ModalDefault = function(param) {
    var children = param.children, className = param.className, isOpen = param.isOpen, modalClassName = param.modalClassName, onBeforeClose = param.onBeforeClose, onDismiss = param.onDismiss, _preventDismiss = param.preventDismiss, preventDismiss = _preventDismiss === void 0 ? false : _preventDismiss, sideModal = param.sideModal, size = param.size, title = param.title, toggle = param.toggle;
    var handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var shouldClose, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (preventDismiss) return [
                        2
                    ];
                    if (!onBeforeClose) return [
                        3,
                        5
                    ];
                    shouldClose = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        onBeforeClose()
                    ];
                case 2:
                    shouldClose = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error("onBeforeClose threw:", err);
                    shouldClose = false;
                    return [
                        3,
                        4
                    ];
                case 4:
                    if (!shouldClose) return [
                        2
                    ];
                    _state.label = 5;
                case 5:
                    onDismiss();
                    toggle();
                    return [
                        2
                    ];
            }
        });
    }), [
        preventDismiss,
        onBeforeClose,
        onDismiss,
        toggle
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(reactstrap__WEBPACK_IMPORTED_MODULE_4__/* .Modal */ .u_, {
        isOpen: isOpen,
        size: size,
        unmountOnClose: true,
        backdrop: preventDismiss ? "static" : true,
        keyboard: !preventDismiss,
        modalClassName: sideModal ? "side-modal" : modalClassName,
        toggle: handleToggle,
        children: [
            !!title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(reactstrap__WEBPACK_IMPORTED_MODULE_4__/* .ModalHeader */ .xB, {
                toggle: !preventDismiss ? handleToggle : undefined,
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(reactstrap__WEBPACK_IMPORTED_MODULE_4__/* .ModalBody */ .fe, {
                className: className,
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalDefault);


/***/ })

}]);